import { Component, OnInit, Input } from '@angular/core';
import { CalendarService } from 'src/app/pages/calendar/services/calendar.service';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-history-user',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit {
  @Input() user: any = undefined;
  public histories: any[] = [];
  public actualMonth = new Date().getMonth();
  public actualYear = new Date().getFullYear();
  public initDate: any[] = [];
  public loading = false;

  constructor(
    private httpSv: HttpService,
    public calendarSv: CalendarService
  ) {}

  ngOnInit() {
    this.getHistory();
  }

  async getHistory() {
    try {
      this.loading = true;
      this.initDate = [];
      const actualDate = new Date();
      const params = {
        userId: this.user.id,
        date: JSON.stringify({
          month: this.actualMonth + 1,
          year: this.actualYear,
        }),
      };
      const res = await this.httpSv.itemIndex('operators/history', '', params);
      const data = res.data;
      const initDate = parseInt(data.dateDomainInit.split('-')[0]);
      const years = actualDate.getFullYear() - initDate;
      for (let index = initDate; index <= initDate + years; index++) {
        this.initDate.push(index);
      }

      const histories: any[] = data.meeting;
      this.histories = histories;
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }
}
